import Vue from 'vue'
import VueI18n from 'vue-i18n'

// Import your translation files
import en from '../locales/en.json'  // Path to your English translations
import hi from '../locales/hi.json'  // Path to your Hindi translations
import id from '../locales/id.json'  // Path to your Indonesian translations
import ta from '../locales/ta.json'  // Path to your Tamil translations
import vi from '../locales/vi.json'  // Path to your Vietnamese translations
import bn from '../locales/bn.json'  // Path to your Vietnamese translations

Vue.use(VueI18n)

export let i18n = new VueI18n({
  locale: 'en',  // Default locale
  fallbackLocale: 'en',  // Fallback to English if translation is not available in the selected locale
  messages: {
    en,  // English translations
    hi,  // Hindi translations
    id,  // Indonesian translations
    ta,  // Tamil translations
    vi,  // Vietnamese translations
    bn
  }
})
